export default __webpack_public_path__ + "static/media/juice-fruit-product-r-desktop@2x.9b35abee.png";